import { Table, Thead, Tbody, Tr, Th, Td, Badge, Tag, TableContainer, Button} from "@chakra-ui/react";
import { useAppContext } from "../../contexts/AppContext";

const DocumentMonitoringTable = () => {
    
    const { formatDate } = useAppContext();
    const documents = [
      { name: "Passport", entity: "John Doe", fund: "Apollo Properties", status: "Missing", expiration: null },
      { name: "Proof of Address", entity: "Company X", fund: "Pinnacle Feeder", status: "Missing", expiration: null },
      { name: "Tax Certificate", entity: "Entity Y", fund: "Titan Real Estate", status: "Expired", expiration: "2023-11-30" },
      { name: "KYC Form", entity: "Individual A", fund: "Vanguard Growth", status: "Missing", expiration: null },
      { name: "Business License", entity: "Company Z", fund: "Vanguard Growth", status: "Expired", expiration: "2023-12-01" },
      { name: "Bank Statement", entity: "Entity C", fund: "Apollo Properties", status: "Missing", expiration: null },
      { name: "Driving License", entity: "Jane Smith", fund: "Helios Feeder", status: "Expired", expiration: "2024-01-10" },
      { name: "Insurance Certificate", entity: "Entity D", fund: "Everest Properties", status: "Expired", expiration: "2023-10-15" },
      { name: "Employment Contract", entity: "Individual E", fund: "Atlas Debt", status: "Missing", expiration: null },
      { name: "AML Certification", entity: "Entity F", fund: "Cosmos Strategies", status: "Expired", expiration: "2023-09-20" },
    ];
  
    return (


      <TableContainer>
    <Table variant="simple" size="sm" mb={6}>
      <Thead>
        <Tr>
          <Th>Document Name</Th>
          <Th>Entity</Th>
          <Th>Fund</Th>
          <Th>Status</Th>
          <Th>Expiration Date</Th>
          <Th>Actions</Th>
        </Tr>
      </Thead>
      <Tbody>
        {documents.map((doc, index) => (
          <Tr key={index}>
            <Td fontWeight={"500"}>{doc.name}</Td>
            <Td><Tag size={"sm"}>{doc.entity}</Tag></Td>
            <Td><Tag colorScheme="brand">{doc.fund}</Tag></Td>
            <Td>
              <Badge colorScheme={doc.status === "Missing" ? "error" : "warning"}>
                {doc.status}
              </Badge>
            </Td>
            <Td>
            <Badge bg={"transparent"}>
                {doc.expiration ? formatDate(doc.expiration) : ""}
            </Badge>
            </Td>
              <Td>
                          <Button size={"xs"} variant={"outline"}>{doc.status === "Missing" ? "Upload" : "Replace"}</Button>
                        </Td>
            </Tr>
        ))}
      </Tbody>
    </Table>
    </TableContainer>

  );
};
export default DocumentMonitoringTable;